<template>
  <div class="px-6 2xl:px-24 py-40 bg-gray-200" id="plans">
    <h3 class="max-w-4xl text-black">{{ $t('FLEXIBLE_PRICE_PLANS') }}</h3>

    <!-- Sections -->
    <div class="block my-14" v-if="plans.length">
      <nv-tabs>
        <nv-tab-button tab="android" selected>{{ $t('VPN_FOR_ANDROID') }}</nv-tab-button>
      </nv-tabs>
    </div>

    <ul v-if="plans.length">
      <!-- Plans cards -->
       <NextGenPlansCard
         v-for="(plan, idx) of plans"
         :key="idx"
         :is-recommeded="plan.is_recommended"
         :limited-offer="plan.limited_offer"
         :bill-cycle="plan.bill_cycle"
         :action-text="$t('subscribe_now')"
         :on-get-plan="() => onChange(plan)"
         :net-value="plan.net_value"
         :bill-interval="plan.bill_interval"
         :value="plan.value"
         :save-discount="plan.discount"
         :show-refound-policy="false"
         :discount-cycle="plan.discount_cycle"
         :show-renew-alert="Boolean(plan.discount)"
         :name="plan.name"
         :privilege-data="plan.privilege_data"
         :is-popular="plan.is_popular"
         :features="plan.features"
         :external-buy-action="plan.externalBuyAction"
       />
    </ul>

    <slot></slot>
  </div>
</template>
<script lang="ts" setup>
// -----------------------------------
// Hooks
// -----------------------------------
const { $formatPrice } = useNuxtApp();

// -----------------------------------
// Props
// -----------------------------------
const props = defineProps({
  plans: {
    type: Array as PropType<Array<{
      is_recommended?: boolean;
      is_popular?: boolean;
      limited_offer?: boolean;
      bill_cycle: string;
      net_value: number;
      bill_interval: number;
      value: number;
      discount_cycle: number;
      discount: number;
      name: string;
      privilege_data?: Record<any, any>
      features?: Array<string>,
      externalBuyAction?: string
    }>>,
    required: false,
    default: () => [],
  },
  onChange: {
    type: Function as PropType<(value: any) => void>,
    required: true,
  },
  unlimitedPlan: {
    type: Object as PropType<{
      is_recommended?: boolean;
      limited_offer?: boolean;
      bill_cycle: string;
      net_value: number;
      bill_interval: number;
      value: number;
      discount_cycle: number;
      discount: number;
      name: string;
      resources?: Array<string>
    }>,
    required: false,
    default: () => null,
  },
  customPlan: { type: Boolean, required: false, default: false },
  resources: {
    type: Array as PropType<Array<string>>,
    required: false,
    default: () => [],
  },
});

// -----------------------------------
// State
// -----------------------------------
const hasUnlimitedPlan = computed(() => Boolean(props.unlimitedPlan));
</script>
<style lang="scss" scoped>
ul {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}


@media (screen(lg)) {
  ul {
    li {
      min-height: 390px;
    }
  }
}
</style>
